import React from 'react';
import { IIconProps } from './IIconProps';
import { OvalStyle } from './OvalStyle';

const ovalEmptyStyle: React.CSSProperties = {
    ...OvalStyle,
    border: '2px solid var(--color-grey-medium)',
}

export const OvalEmptyIcon = ({ className, style }: IIconProps) => <div className={className} style={{ ...ovalEmptyStyle, ...style }}></div>